// Make description of checkbox clickable
let checkboxFromItems = document.querySelectorAll('.form-type-checkbox');

if (!_.isEmpty(checkboxFromItems)) {
    checkboxFromItems.forEach((checkbox) => {
        let checkboxDescription = checkbox.querySelector('.description');

        if (!_.isNil(checkboxDescription)) {
            checkboxDescription.style.cursor = 'pointer';

            checkboxDescription.addEventListener('click', (e) => {
                if (e.target.tagName === 'A') {
                    return;
                }

                let checkboxInput = checkbox.querySelector('input');

                if (_.isNil(checkboxInput)) {
                    return;
                }

                checkboxInput.checked = !checkboxInput.checked;
            })
        }
    })
}

const registrationRadios = document.querySelectorAll('.paragraph-registration-date');
const registrationTimeFormElement = document.querySelector('.webform-submission-registration-form-form input[name=chosen_date]');

if (!_.isEmpty(registrationRadios) && !_.isNil(registrationTimeFormElement)) {
    Array.from(registrationRadios).forEach((radio) => {
        const radioButton = radio.getElementsByTagName('input')[0];

        if(!_.isEmpty(registrationTimeFormElement.value)) {
            if(registrationTimeFormElement.value === radioButton.value) {
                radioButton.checked = true;
            }
        }

        if (radioButton.checked) {
            registrationTimeFormElement.value = radioButton.value;
        }

        radioButton.addEventListener('change', (e) => {
            registrationTimeFormElement.value = radioButton.value;
        });
    });
}

const addEmailListener = () => {
    const trainingFormPersonEmailInput = document.querySelector('form.webform-submission-registration-form-form div[id^="number_of_persons_table"] table tbody > tr:first-of-type .form-item.form-type-email input');
    const trainingsFormMainPersonEmailInput = document.querySelector('form.webform-submission-registration-form-form .form-item-requester-email input');

    if (_.isNil(trainingFormPersonEmailInput) || _.isNil(trainingsFormMainPersonEmailInput)) {
        return;
    }

    document.querySelector('form.webform-submission-registration-form-form .form-item-requester-email')?.classList.add('visually-hidden');

    if (trainingFormPersonEmailInput.value) {
        trainingsFormMainPersonEmailInput.value = trainingFormPersonEmailInput.value;
    }

    trainingFormPersonEmailInput.addEventListener('input', (event) => {
        trainingsFormMainPersonEmailInput.value = event.target.value;
    })
}

addEmailListener()

Drupal.behaviors.trainingFormInput = {
    attach: function(context, settings) {
        if (_.isNil(context.classList) || !context.classList.contains('webform-submission-registration-form-form')) {
            return;
        }

        addEmailListener();
    }
}

const trialSessionField = document.querySelector('form.webform-submission-proefsessie-boeken-form .view-trial-sessions-cursus .views-field-title');
const hiddenCourseInput = document.querySelector('form.webform-submission-proefsessie-boeken-form input[name=training]')
const defaultTrainingField = document.querySelector('form.webform-submission-proefsessie-boeken-form .manual-chosen-training-wrapper')

const checkTrialFormFields = (hiddenCourseInput, chosenCourse, defaultTrainingField) => {
    const manualTrainingWrapper = document.getElementById('webform-computed-chosen_training-wrapper')

    if (_.isNil(hiddenCourseInput) && _.isNil(manualTrainingWrapper) && _.isNil(defaultTrainingField)) {
        return;
    }

    if (_.isEmpty(chosenCourse)) {
        manualTrainingWrapper.style.display = "none";
        return;
    }

    hiddenCourseInput.value = chosenCourse
    defaultTrainingField.style.display = "none"
}

const chosenCourse = trialSessionField?.querySelector('.field-content')?.textContent?.trim();
checkTrialFormFields(hiddenCourseInput, chosenCourse, defaultTrainingField)